import { faCirclePlus } from "@fortawesome/pro-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Button, Chip, Typography } from "@mui/material"
import { translate } from "app/language/service"
import { IGeoTargetsForm } from "form/model"
import { setGeoTargetsForm } from "form/tools/geo-targets"
import { addShapes, isShapeAlreadySelected, selectShapeInForm } from "form/tools/geo-targets-shapes"
import React from "react"
import { getShapeTitle } from "shape/tools/common"
import { FlexBox } from "ui/components/FlexBox"
import { LinearLoader } from "ui/components/LinearLoader"
import { ShapeSelect } from "./ShapeSelect"

interface IGeoTargetsShapeFormProps {
  geoTargetsForm: IGeoTargetsForm
}

export const GeoTargetsShapeForm = React.memo(({ geoTargetsForm }: IGeoTargetsShapeFormProps): JSX.Element => {
  const { toAddShape: selectedShape, isSelectingShape } = geoTargetsForm
  const submit = async () => {
    if (!selectedShape) {
      return
    }
    await addShapes([selectedShape])
    setGeoTargetsForm({ toAddShape: null })
  }
  const alreadySelected = selectedShape === null ? false : isShapeAlreadySelected(selectedShape)
  return (
    <FlexBox
      vertical
      fullWidth
      gap
      sx={{
        "& > *": { width: "100%" }
      }}>
      <ShapeSelect onSelect={newShape => selectShapeInForm(newShape)} />
      {alreadySelected && (
        <Typography id="geo-target-shape-error-already-selected" color="error" fontSize=".8rem">
          {translate("campaign.geo-targets.shape.already.selected")}
        </Typography>
      )}
      <FlexBox
        jc="end"
        wrap
        gap
        sx={{
          "& .icon": {
            cursor: "pointer",
            color: theme => theme.palette.text.primary,
            fontSize: "1.5rem"
          }
        }}>
        {isSelectingShape ? (
          <LinearLoader
            id="geo-target-shape-is-selecting"
            text={translate("campaign.geo-targets.shape.selecting")}
            sx={{
              "width": "10rem",
              "& > p": {
                fontSize: ".9rem"
              },
              "& > span": { mb: 0 }
            }}
          />
        ) : !selectedShape ? (
          <Typography
            id="geo-target-shape-no-selection"
            color={!selectedShape ? "textSecondary" : "textPrimary"}
            fontSize=".85rem">
            {translate("campaign.geo-targets.shape.not.selected")}
          </Typography>
        ) : (
          <Chip
            id="geo-target-shape-chip"
            label={getShapeTitle({
              shape: selectedShape,
              withType: true
            })}
            variant="outlined"
            onDelete={() => selectShapeInForm(null)}
          />
        )}
        <Button
          id="geo-target-shape-add-button"
          disabled={selectedShape === null || alreadySelected}
          variant="outlined"
          size="small"
          onClick={() => submit()}
          startIcon={<FontAwesomeIcon icon={faCirclePlus} />}>
          {translate("button.add")}
        </Button>
      </FlexBox>
    </FlexBox>
  )
})
